<script setup>
import { ref } from 'vue'
const props = defineProps({
  text: String,
  color: String,
  bgColor: String,
  icon: String,
  iconAlt: String,
  dismissable: {
    type: Boolean,
    default: true,
  },
})
const show = ref(true)

</script>

<template>
  <div
    v-show="show"
    class="py-[11px] px-[17px] flex items-center justify-between rounded-lg mt-5 max-lg:mx-4 max-lg:mb-5"
    :style="{ 'background-color': props.bgColor }"
  >
    <p class="flex items-center gap-2">
      <span>
        <img :src="versionAsset('/assets/shared/img/nudges/' + icon)" :alt="iconAlt" />
      </span>
      <span
        v-html="props.text"
        :style="{ color: props.color }"
        class="leading-[18px] text-sm font-normal"
      />
    </p>
    <button v-if="dismissable" class="cursor-pointer" @click="show = !show">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 6L18.7742 18.7742" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M6 18.7742L18.7742 5.99998" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
    </button>
  </div>
</template>

<style scoped>

</style>
